import * as types from './actionTypes';

export default mode => ({
  type: types.SET_ORIGIN,
  payload: mode,
});
